export enum USER_ROLES {
  CAR_AGENT = 1,
  ADMIN = 2,
  NDV_AGENT = 3,
}
